module.exports = __webpack_public_path__ + "img/heart-filled.84863501.svg";